// removed by extract-text-webpack-plugin
module.exports = {"subscriptionList":"_2rlAOtJKRVMrq5tHGfnsaW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscriptionsList/SubscriptionsList.scss
// module id = 1797
// module chunks = 0